import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowLeftIcon, PaletteIcon, PenToolIcon, LayersIcon, UserIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLidLoisPage: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2240">
      <SEO title="Loïs Bruins - Junior Vormgever | Noord Digital" description="Maak kennis met Loïs Bruins, Junior Vormgever bij Noord Digital. Vertaalt strategie en merk naar visueel werk dat klopt en converteert." canonical="https://noorddigital.nl/over-ons/lois" data-id="element-2241" />
      <Header data-id="element-2242" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2243">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2244">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2245">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2246" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2247">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2248">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] bg-gradient-to-br from-[#EEF5FA] to-[#DCE9F5] flex items-center justify-center shadow-lg overflow-hidden" data-id="element-2249">
                <img src="https://cdn.magicpatterns.com/uploads/24tAJ2MdsgDjmhw3y14fYd/Norden_Lois.png" alt="Loïs Bruins" className="w-full h-full object-cover" data-id="element-2250" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2251">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2252">
                Loïs Bruins
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2253">
                Junior Vormgever
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2254">
                <p className="mb-4" data-id="element-2255">
                  Als Junior Vormgever bij Noord Digital maak ik de designs voor
                  onze projecten. Van website-pagina's tot social posts en
                  campagnemateriaal: ik zorg dat het er strak en consistent
                  uitziet.
                </p>
                <p className="mb-4" data-id="element-2256">
                  Ik vertaal de strategie en het merk van een klant naar visueel
                  werk dat klopt. Niet alleen mooi, maar ook duidelijk — zodat
                  de juiste boodschap meteen overkomt en bezoekers weten wat ze
                  moeten doen.
                </p>
                <p data-id="element-2257">
                  Ik leer elke dag bij van het team en werk graag mee in
                  iteraties. Feedback is geen kritiek maar materiaal om het
                  ontwerp scherper te maken.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2258">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2259">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2260">
                  <PaletteIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2261" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2262">Visueel ontwerp</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2263">
                  <PenToolIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2264" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2265">Branding</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2266">
                  <LayersIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2267" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2268">Web design</h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2269">
                Neem contact op met Loïs
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2270" />
    </div>;
};